import React from 'react'
import Navbar from './Navbar'

const Header = () => {
  return (
    <div className='fixed text-gray-400 bg-gray-900 w-[100%] z-40'>
        <Navbar />
    </div>
  )
}

export default Header